import React, { useState, useEffect, useRef, useContext } from 'react';
import '../App.css';
import { connect } from 'react-redux'
import { SearchOutlined, PlusCircleOutlined, DeleteOutlined, DownOutlined, CaretDownOutlined, CloseOutlined, LeftOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Button, Input, Space, Table, Tag, Modal, ConfigProvider, Select, Collapse, Progress, Form, Col, Row, DatePicker, Spin, Upload, message, Popconfirm, Dropdown, Popover, AutoComplete, Pagination, Skeleton } from 'antd';
import { Document, Page } from 'react-pdf';
import { Rnd } from "react-rnd";
import "./Tasks.css"
import { application } from '../State';
import { divideStringByCapitalLetter, documents } from '../Common';
const { Dragger } = Upload;
const EditableContext = React.createContext(null);
const mapStateToProps = (state) => {
    return {
        application: state.application,
        progress: state.progress,
        borrower: state.borrower,
    }
}

const mapDispatchToProps = (dispatch) => ({
});

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    )
}
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false)
    const inputRef = useRef(null)
    const form = useContext(EditableContext)
    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);
    const disabledDate = (current) => {
        return current && current < dayjs().endOf('day');
    }
    const toggleEdit = () => {
        if (!record.remove) {
            return false
        }
        setEditing(!editing)
        form.setFieldsValue({
            [dataIndex]: record[dataIndex] ? dayjs(record[dataIndex], 'MM/DD/YYYY') : null,
        })
    }
    const save = async () => {
      try {
        const values = await form.validateFields()
        toggleEdit()
        const formattedDate = dayjs(values[dataIndex]).format('MM/DD/YYYY')
        handleSave({
          ...record,
          [dataIndex]: formattedDate,
        });
      } catch (errInfo) {
        toggleEdit()
        const formattedDate = dayjs(record[dataIndex]).format('MM/DD/YYYY')
        handleSave({
          ...record,
          [dataIndex]: formattedDate,
        });
        console.log('Save failed:', errInfo)
      }
    };
    let childNode = children
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                margin: 0,
                }}
                name={dataIndex}
                rules={[
                {
                    required: true,
                    message: `${title} is required.`,
                },
                ]}
            >
                
                <DatePicker
                    ref={inputRef}
                    onChange={save}
                    onBlur={save}
                    style={{width: '100%'}}
                    disabledDate={disabledDate}
                    placeholder="MM/DD/YYYY"
                    format={{
                        format: "MM/DD/YYYY",
                        type: 'mask',
                    }}
                    suffixIcon={null}
                    autoFocus
                />
            </Form.Item>
          ) : (
            <div
              className="table-date"
              onClick={toggleEdit}
            >
              {children}
            </div>
          )
    }
    return <td {...restProps}>{childNode}</td>
}
export default function Tasks(props) {
    const [form] = Form.useForm()
    const tableRef = useRef(null)
    const containerRef = useRef(null)
    const [modal, contextHolder] = Modal.useModal()
    const [addItemType, setAddItemType] = useState("")
    const [editingTaskIndex, setEditingTaskIndex] = useState(-1)
    const [editingMsgIndex, setEditingMsgIndex] = useState(-1)
    const [loading, setLoading] = useState(false)
    const [saveLoading, setSaveLoading] = useState(false)
    const [tasksLoading, setTasksLoading] = useState(false)
    const [showCreateNewModal, setShowCreateNewModal] = useState(false)
    const [showSignatureModal, setShowSignatureModal] = useState(false)
    const [succeed, setSucceed] = useState(false)
    const [taskDocuments, setTaskDocuments] = useState([])
    const [addDocument, setAddDocument] = useState(false)
    const [searchedStatus, setSearchedStatus] = useState("")
    const [taskList, setTaskList] = useState([])
    const [isViewfilesOpen, setIsViewfilesOpen] = useState(false)
    const [file, setFile] = useState([])
    const [uploadFile, setUploadFile] = useState(null)
    const [fileIndex, setFileIndex] = useState(0)
    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)
    const [scale, setScale] = useState(1);
    const [pageWidth, setPageWidth] = useState(window.innerWidth)
    const [markList, setMarkList] = useState([])
    const [documentOptions, setDocumentOptions] = useState([])
    const [handleTransitionOpen, setHandleTransitionOpen] = useState(false)
    useEffect(() => {
        getusertasks()
        const handleResize = () => {
            let width = window.innerWidth
            if (width < 1312) {
                setPageWidth(window.innerWidth - 100)
            } else {
                setPageWidth(1200)
            }
        }
        handleResize()
        window.addEventListener('resize', handleResize)
    
        return () => {
          window.removeEventListener('resize', handleResize)
        }
    }, [])
    useEffect(() => {
        setAddDocument(taskDocuments.length === 0)
    }, [taskDocuments])
    const setTransitioncheck = () => {
        let token = sessionStorage.getItem("ZeitroA")
        let api = '/los/transitioncheckvisited'
        fetch(api, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                if (response.status !== 200) {
                    console.log("Error post /los/getdocuments/:", response)
                    return;
                }
                setHandleTransitionOpen(true)
            }
    
        ).catch((err) => {
            console.log(err)
        })
    }
    const showCoborrower = () => {
        if (props.application.hascoborrower === "withcoborrower" && props.application.married) return true
        return false
    }
    const mergeTasks = (list) => {
        let updatedTaskList = []
        let tasksByType = {}
        list.forEach(task => {
            if (!(task.TaskType in tasksByType)) {
                tasksByType[task.TaskType] = []
            }
            tasksByType[task.TaskType].push(task)
        })
        for (let taskType in tasksByType) {
            let tasks = tasksByType[taskType]

            tasks.sort((a, b) => b.ID - a.ID)

            for (let i = 0; i < tasks.length; i++) {
                let currentTask = tasks[i]
                let mergedTask = { ...currentTask }

                if (taskType === 'action') {
                    for (let j = i + 1; j < tasks.length; j++) {
                        let nextTask = tasks[j]
                        mergedTask.Items.push(...nextTask.Items)
                    }
                }else {
                    for (let j = i + 1; j < tasks.length; j++) {
                        let nextTask = tasks[j]
                        mergedTask.Documents.push(...nextTask.Documents)
                    }
                }
                updatedTaskList.push(mergedTask)
                i = tasks.length
            }
        }
        return updatedTaskList
    }
    const getusertasks = () => {
        let token = sessionStorage.getItem("ZeitroA")
        setTasksLoading(true)
        fetch('/los/getusertasks/'+props.loanid, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                setTasksLoading(false)
                if (response.status !== 200) {
                    console.log("Error post /los/getusertasks/:", response)
                    return;
                }
                response.json().then(data => {
                    const filterData = data.filter(item => item.TaskType !== 'upload')
                    const tasks = filterData.length > 0 ? mergeTasks(filterData) : []
                    const taskTypes = ['action', 'sign']
                    const missingTaskTypes = taskTypes.filter(type => !tasks.some(task => task.TaskType === type))
                    missingTaskTypes.forEach(type => {
                        tasks.push({ Created: '', Deadline: '', Documents: [], ForWhom: '', ID: '', Items: [], Status: 'open', TaskID: 'other', TaskType: type, name: `New ${type} Task` });
                    })
                    console.log(tasks, 'tasks')
                    setTaskList(tasks)
                })
            }
    
        ).catch((err) => {
            setTasksLoading(false)
            console.log(err)
        })
    }
    
    const deleteuserdocument = (id, type) => {
        let token = sessionStorage.getItem("ZeitroA")
        let api = type === 'action' ? '/los/deleteuseractionitem/' : '/los/deleteuserdocument/'
        fetch(api + id, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
        }).then(
            response => {
                if (response.status !== 200) {
                    return;
                }
                message.success({
                    type: 'success',
                    content: 'Delete successful!',
                })
                getusertasks()
            }
        ).catch((err) => {
            console.log(err)
        });
    }
    
    const mapType = (type) => {
        let map = {
            upload: 'Document upload',
            sign: 'Document sign',
            action: 'Customized task'
        }
        return map[type]
    }
    const noTasks = (item) => {
        if (item.TaskType === 'action') {
            return item.Items.length === 0
        } else {
            return item.Documents.length === 0
        }
    }
    const showCurrentTasks  = () => {
        
        const customHeader = (item) => {
            let percent = 0
            let completed = 0
            if (item.TaskType === 'upload') {
                completed = item.Documents.filter(file => file.Data).length
                percent = (completed / item.Documents.length) * 100
            } else {
                if (item.TaskType === 'action') {
                    completed = item.Status === 'closed' ? item.Items.length : 0
                } else {
                    completed = item.Status === 'closed' ? item.Documents.length : 0
                }
                percent = item.Status === 'closed' ? 100 : 0
            }
            return (
                <div className='task-collapse-header'>
                    <div className="task-type">{mapType(item.TaskType)}</div>
                    <div className={`task-update ${ noTasks(item) ? 'no-tasks-text' : ''}`}>Latest update on { noTasks(item) ? <span>--</span> : dayjs(item.Deadline).format('MM/DD/YYYY')}</div>
                    <div className="task-completed"><Progress type="circle" percent={percent} size={36} strokeWidth={14} trailColor="#E3EAFD" strokeColor="#325CEB" format={() => <span style={{fontSize: 14, color: '#325CEB', fontWeight: 700}}>{completed}</span>} /><span className="task-completed-num">{ noTasks(item) ? <span className='no-tasks-text'>No tasks</span> : `${completed} / ${item.TaskType === 'action' ? item.Items.length : item.Documents.length} COMPLETED`}</span></div>
                </div>   
            )
        }
        const handleDelete = (record, type) => {
            deleteuserdocument(record.ID, type)
        }
        const handleStatusChange = (record, newStatus, index) => {
            const updatedTaskList = [...taskList]
            const currentTask = updatedTaskList.find(item => item.ID === record.ID)
            if (currentTask) {
                const currentDocument = currentTask.Documents[index]
                if (currentDocument) {
                    currentDocument.status = newStatus
                }
            }
            setTaskList(updatedTaskList)
        }
        const checkFile = (record, index) => {
            setFile(record.file)
            setFileIndex(index)
            setIsViewfilesOpen(true)
        }
        const columnsData = (type, status) => {
            const taskColumns = [
                {
                    title: type === 'action' ? 'Description' : 'Document',
                    width: 450,
                    render: (_, record) => (
                        <div className="document-name-wrap">
                            <span className="table-document">{ type === 'action' ? record.Description : record.FileName }</span>
                            {/* { record.file && record.file.length > 0 && 
                                record.file.map((item, index) => (
                                    <div className="table-document-file" key={index} onClick={() => checkFile(record, index)}><img src="/images/pdf4.svg" /><div className="table-document-name">{item.filename}</div></div>
                                ))
                            } */}
                            
                        </div>  
                    ),
                },
                {
                    title: 'Due date',
                    dataIndex: 'DueDate',
                    key: 'DueDate',
                    width: 150,
                    render: (text) => <span className="table-date">{dayjs(text).format('MM/DD/YYYY')}</span>,
                },
                {
                    title: 'Status',
                    dataIndex: 'Data',
                    key: 'Data',
                    width: 150,
                    filteredValue:[searchedStatus],
                    onFilter: (value, record) => {
                        if (value === 'pending') {
                            if (type === 'upload') {
                                return !record.Data
                            } else {
                                return status !== 'closed'
                            }
                        } else if (value === 'submitted') {
                            if (type === 'upload') {
                                return record.Data
                            } else {
                                return status === 'closed'
                            }
                        }
                        return true
                    },
                    render: (_, record, index) => {
                        // const statusMap = {
                        //     'pending': 'Pending',
                        //     'submitted': 'Submitted'
                        // }
                        // const items = Object.entries(statusMap).map(([key, val]) => {
                        //     return {
                        //         key: key,
                        //         label: (
                        //             <a onClick={() => handleStatusChange(record, key, index)}>
                        //             {val}
                        //             </a>
                        //         ),
                        //     }
                        // })
                        const splitStatusByWords = (val) => {
                            if (type === 'upload') {
                                return val ? 'Submitted' : 'Pending'
                            } else {
                                return val === 'closed' ? 'Submitted' : 'Pending'
                            }
                        }
                        const mapStatusTagColor = (val) => {
                            if (type === 'upload') {
                                return val ? '#F8E8D3' : '#DBDCDE'
                            } else {
                                return val === 'closed' ? '#F8E8D3' : '#DBDCDE'
                            }
                        }
                        return <div className="loansStatus">
                            <Tag
                            bordered={false}
                            color={mapStatusTagColor(type === 'upload'? record.Data : status)}
                            style={{width: 84, textAlign: 'center', borderRadius: 4}}
                            className="loansStatusTag" >
                            {splitStatusByWords(type === 'upload'? record.Data : status)}
                            </Tag>
                            {/* <Dropdown
                                menu={{items,}}
                                placement="bottomLeft"
                                arrow
                            >
                                <Button className="loanStatusSelect" >
                                    <CaretDownOutlined style={{fontSize:11}}/>
                                </Button>
                            </Dropdown> */}
                        </div>
                    },
                },
                {
                    title: '',
                    dataIndex: '',
                    key: '',
                    fixed: 'right',
                    width: 60,
                    render: (_, record, index) => (
                        <Space size="middle">
                        <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record, type)}>
                            <img style={{width: 24, height: 24, cursor: 'pointer'}} src="/images/delete.png" />
                        </Popconfirm>
                        </Space>
                    ),
                },
            ]
            return taskColumns
        }
        const dataSourceKey = (type) => {
            if (type === 'action') {
                return 'Items'
            } else {
                return 'Documents'
            }
        }
        const statusList = [
            {
                label: 'Pending',
                value: 'pending'
            },
            {
                label: 'Submitted',
                value: 'submitted'
            }
        ]
        const showCreateModal = () => {
            resetForm()
            setSucceed(false)
            setTaskDocuments([])
            setDocumentOptions(Object.values(documents).map(value => value[0]))
            setAddItemType("")
            setAddDocument(false)
            if (!showCoborrower()) {
                form.setFieldsValue({
                    borrower: 'borrower', 
                })
            }
            setShowCreateNewModal(true)
        }
        const onDocumentLoadSuccess = ({ numPages }) => {
            setNumPages(numPages)
            setPageNumber(1)
        }
        const prevPage = () => {
            if (pageNumber === 1) {
                return
            }
            setPageNumber(pageNumber - 1)
        }
        const nextPage = () => {
            if (pageNumber === numPages) {
                return
            }
            setPageNumber(pageNumber + 1)
        }
        const downLoadFile = () => {
            const task = {

            }
        }
        const documentTotal = () => {
            let totalLength = 0
            if (taskList.length > 0) {
                taskList.forEach(task => {
                    if (task.TaskType === 'action') {
                        totalLength += task.Items.length
                    } else {
                        totalLength += task.Documents.length
                    }
                })
            }
            return totalLength
        }
        return <div className="currentTasksWrap">
            <Spin spinning={tasksLoading}>
            <Modal className='viewFiles-modal' maskClassName="viewFiles-modal-mask" centered width={1280} zIndex={1002} closable={false} open={isViewfilesOpen}
                footer={null}
            >
                <div className='viewFiles-content'>
                    <Document file={file[fileIndex]?.url} onLoadSuccess={onDocumentLoadSuccess} >
                        <Page pageNumber={pageNumber} width={pageWidth} />
                    </Document>
                </div>
                <div className='viewfiles-top-bar'>
                    <div><CloseOutlined className='close-icon' onClick={() => setIsViewfilesOpen(false)} /><img style={{width: 22, height: 22}} src='/images/pdf2.png' /><span className='viewfiles-top-name'>{file[fileIndex]?.filename}</span></div>
                    <Button key="submit" className='viewFiles-modal-btn btn-default' type="primary" onClick={downLoadFile}>
                        DownLoad
                    </Button>
                    <div className='page-info'>{pageNumber} / {numPages}</div>
                </div>
                {pageNumber !== 1 && <img className='viewfiles-prevPage' style={{width: 69, height: 69}} src='/images/left-arrow.svg' onClick={prevPage} />}
                {pageNumber !== numPages && <img className='viewfiles-nextPage' style={{width: 69, height: 69}} src='/images/right-arrow.svg' onClick={nextPage} />}
            </Modal>
            <div className="task-num">{documentTotal()} Task</div>
            <div className="task-topBar">
                <div className="search-bar">
                    <Select
                        className="statusFilters"
                        placeholder="Status"
                        onChange={(value) => setSearchedStatus(value)}
                        allowClear
                        >
                        {statusList.map(s => (
                            <Select.Option key={s.value} value={s.value}>{s.label}</Select.Option>
                        ))}
                    </Select>
                </div>
                <div className="create-task" onClick={showCreateModal}>Create new task</div>
            </div>
            
            <div className="task-content">
                {
                    taskList.length > 0 ? (
                        <Collapse className='task-collapse' collapsible="icon" expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />} expandIconPosition="end">
                            {
                                taskList.map(item => (
                                    <Collapse.Panel className="task-collapse-item" header={customHeader(item)} key={item.ID}>
                                        <div className="table-wrap">
                                            <Table className="task-table" scroll={{ x: 810 }} pagination={false} columns={columnsData(item.TaskType, item.Status)} dataSource={item[dataSourceKey(item.TaskType)]} />
                                        </div>
                                        
                                    </Collapse.Panel>
                                ))
                            }
                        </Collapse>
                    ) : (
                        <div className="no-tasks p-3">
                            <Skeleton active />
                        </div>
                    )
                }
            </div>
            </Spin>
        </div>
    }
    const tagRender = (props) => {
        const { label, value, closable, onClose } = props
        const onPreventMouseDown = (event) => {
            event.preventDefault()
            event.stopPropagation()
        }
        return (
            <Tag
            color="#EAEFFD"
            onMouseDown={onPreventMouseDown}
            closable={closable}
            onClose={onClose}
            closeIcon={<img style={{marginLeft: 10}} src='/images/tag-close.svg'/>}
            style={{
                marginInlineEnd: 4,
                color: '#325CEB',
                padding: '0 8px 0 10px',
                height: 40,
                display: 'flex',
                alignItems: 'center',
                fontSize: 16,
                fontWeight: 500
            }}
            >
            {label}
            </Tag>
        )
    }
    const getNameOptions = () => {
        // joint
        const nameOptions = [
            {
                label: props.application.borrower.firstname + " " + props.application.borrower.lastname,
                value: 'borrower',
            }
        ]
        if (showCoborrower()) {
            nameOptions.push(
                {
                    label: props.application.coborrower.firstname + " " + props.application.coborrower.lastname,
                    value: 'coborrower',
                }
            )
        }
        return nameOptions
    }
    const typeOptions = [
        {
            label: 'Document upload',
            value: 'upload'
        },
        {
            label: 'Document sign',
            value: 'sign'
        },
        {
            label: 'Action items',
            value: 'action'
        }
    ]
    const handleDelete = (index) => {
        const updatedTaskDocuments = [...taskDocuments]
        updatedTaskDocuments.splice(index, 1)
        setTaskDocuments(updatedTaskDocuments)
    }
    const getAutogenerateDoc = () => {
        let token = sessionStorage.getItem("ZeitroA")
        setLoading(true)
        fetch('/los/gendocs/'+props.loanid, {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                BorrowerID: props.borrower.id,
                Tasks:[]
            }),

        }).then(
            response => {
                setLoading(false)
                // if (response.status !== 200) {
                //     console.log("Error post /los/getusertasks/:", response)
                //     return;
                // }
                response.json().then(js => {
                    if (js.error) return
                    let data = js.docs
                    if (data && data.length > 0) {

                        let autoDocuments = data.filter(d=> d.from !== "system" && d.from !== "loanofficer").map((doc, index) => ({ key: index, name: divideStringByCapitalLetter(doc.docname),duedate: dayjs().add(3, 'day').format('MM/DD/YYYY'), message: '', forWhom: '', remove: true }))
                        setTaskDocuments(autoDocuments)
                        message.success({
                            content: `${autoDocuments.length} documents were auto-generated for your task.`,
                            className: 'task-message'
                        })
                    } else {
                        setTaskDocuments([])
                    }
                }).catch((err) => {
                    setTaskDocuments([])
                })
            }
    
        ).catch((err) => {
            setLoading(false)
            console.log(err)
        })
    }
    const disabledDate = (current) => {
        return current && current < dayjs().endOf('day');
    }
    const typeChange = (value) => {
        if (value === 'upload') {
            setTransitioncheck()
        }
        form.resetFields(['name', 'addDueDate', 'message'])
        setTaskDocuments([])
        if (value === 'action') {
            let actionTaks = taskList.filter(item => item.TaskType === 'action')
            if (actionTaks.length > 0 && actionTaks[0].Items.length > 0) {
                let taskDocuments = actionTaks[0].Items.map((doc, index) => ({ key: index, name: doc.Description, duedate: dayjs(doc.DueDate).format('MM/DD/YYYY'), message: '', forWhom: '' , remove: false }))
                setTaskDocuments(taskDocuments)
            } else {
                setTaskDocuments([])
            }
        } else if (value === 'sign') {
            let uploadTaks = taskList.filter(item => item.TaskType === value)
            console.log(uploadTaks)
            if (uploadTaks.length > 0 && uploadTaks[0].Documents.length > 0) {
                let taskDocuments = uploadTaks[0].Documents.map((doc, index) => ({ key: index, name: doc.FileName, duedate: dayjs(doc.DueDate).format('MM/DD/YYYY'), message: doc.Comment, forWhom: '', remove: false }))
                setTaskDocuments(taskDocuments)
            } else if (value === 'upload') {
                getAutogenerateDoc()
            }
        }
    }
    const draggerProps = {
        name: 'file',
        fileList: taskDocuments,
        showUploadList: false,
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
            console.log(info.file, info.fileList);
            }
            if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
            }
            setUploadFile(info.file)
            setPageNumber(1)
            setMarkList([])
            setScale(1)
            setShowSignatureModal(true)
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
        beforeUpload: (file) => {
            const allowedFileTypes = ['application/pdf']
            const fileType = file.type
            const isAllowed = allowedFileTypes.includes(fileType)
            if (!isAllowed) {
                message.warning('You can only upload PDF files.')
                return Upload.LIST_IGNORE
            }
            return false
        },
    }
    const changeAddDocument = () => {
        setAddDocument(true)
        form.resetFields(['name', 'addDueDate', 'message'])
    }
    useEffect(() => {
        if (tableRef.current) {
            const tableContainer = document.querySelector('.task-table .ant-table-body')
            if (tableContainer) {
                tableContainer.scrollTop = 0
            }
        }
    }, [taskDocuments.length])
    const cancelDocument = () => {
        setAddDocument(false)
    }
    const saveDocument = () => {
        form.validateFields(['name', 'addDueDate']).then((values) => {
            console.log(values)
            const addDocument = {
                key: Math.random().toString(36).substring(2, 10),
                name: values.name,
                duedate: dayjs(values.addDueDate).format('MM/DD/YYYY'),
                message: form.getFieldValue('message'),
                remove: true, 
                forWhom: ''
            }
            const updatedTaskDocuments = [addDocument, ...taskDocuments]
            console.log(updatedTaskDocuments)
            setTaskDocuments(updatedTaskDocuments)
            setAddDocument(false)
        })
        .catch((errorInfo) => {
            console.log('Validation failed:', errorInfo)
        })
    }
    const handleSave = (row) => {
        const newData = [...taskDocuments]
        let key = form.getFieldValue('type') === 'sign' ? 'uid' : 'key'
        const index = newData.findIndex((item) => row[key] === item[key])
        const item = newData[index]
        newData.splice(index, 1, {
          ...item,
          ...row,
        })
        setTaskDocuments(newData)
    }
    const handleValuesChange = (changedValues, allValues) => {
        
    }
    const validateForm = () => {
        form.validateFields().then((values) => {
            let currentTaks = taskList.filter(item => item.TaskType === values.type && item.ID !== '')
            console.log(values, currentTaks)
            if (currentTaks.length > 0) {
                let taskId = currentTaks[0].ID
                if (currentTaks[0].TaskType === 'sign') {
                    updateSignTask(taskId)
                } else {
                    updateTasks(taskId)
                }
                
            } else {
                if (form.getFieldValue('type') === 'sign') {
                    saveSignTask()
                } else {
                    saveTasks()
                }
                
            }
        })
        .catch((errorInfo) => {
            console.log('Validation failed:', errorInfo)
        })
    }
    const resetForm = () => {
        form.resetFields()
    }
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    }
    const editMsg = (index, newValue) => {
        const newData = [...taskDocuments];
        newData[index].message = newValue;
        setTaskDocuments(newData)
    }
    const editName = (index, newValue) => {
        const newData = [...taskDocuments];
        newData[index].name = newValue;
        setTaskDocuments(newData)
    }

    const changeDocumentName = (val) => {
        let options = Object.values(documents).map(value => value[0])
        if (val !== '' && options.some(str => str.includes(val))) {
            setDocumentOptions(options.filter(option => option.toLowerCase().indexOf(val.toLowerCase()) >= 0))
        } else{
            setDocumentOptions(options)
        }
    }
    const taskDocumentsColumns = [
        {
            title: form.getFieldValue('type') === 'action' ? 'Item description' : 'Document',
            dataIndex: 'name',
            key: 'name',
            width: 300,
            render: (text, record, index) => {
                if (form.getFieldValue('type') === 'action' && index === editingMsgIndex) {
                    return (
                        <Input
                            type="text"
                            value={text}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                editName(index, newValue);
                            }}
                            autoFocus
                            onPressEnter={() => setEditingMsgIndex(-1)}
                            onBlur={() => setEditingMsgIndex(-1)}
                        />
                    )
                } else {
                    return <span className='table-document' onClick={() => form.getFieldValue('type') === 'action' && setEditingMsgIndex(index)}>{text}</span>
                }
            },
        },
        {
            title: 'Due date',
            dataIndex: 'duedate',
            key: 'duedate',
            width: 150,
            editable: true,
        },
        {
            title: 'Message',
            dataIndex: 'message',
            key: 'message',
            hidden: form.getFieldValue('type') === 'action',
            width: 300,
            render: (text, record, index) => {
                if (index === editingTaskIndex) {
                    return (
                        <Input
                            type="text"
                            value={text}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                editMsg(index, newValue);
                            }}
                            autoFocus
                            onPressEnter={() => setEditingTaskIndex(-1)}
                            onBlur={() => setEditingTaskIndex(-1)}
                        />
                    )
                } else if (text === '') {
                    return record.remove ? <div className='message-add' onClick={() => setEditingTaskIndex(index)}>Add</div> : ''
                } else {
                    return <div className='table-message'><div className='message-text'>{text}</div>{record.remove && <span className='message-edit' onClick={() => setEditingTaskIndex(index)}>Edit</span>}</div>
                }
            }
        },
        {
            title: '',
            dataIndex: '',
            key: '',
            fixed: 'right',
            width: 60,
            render: (_, record, index) => (
                <Space size="middle">
                    {
                        record.remove && (
                            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(index)}>
                                <img style={{width: 24, height: 24, cursor: 'pointer'}} src="/images/delete.png" />
                            </Popconfirm>
                        )
                    }
                </Space>
            ),
        },
    ]
    const columns = taskDocumentsColumns.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave,
          }),
        }
    }).filter(v => !v.hidden)
    const taskType = () => {
        if (form.getFieldValue('type') === 'upload' || addItemType === 'upload') {
            return 'upload'
        } else if (form.getFieldValue('type') === 'action' || addItemType === 'action') {
            return 'action'
        }
    }
    const showCreateNewTasks = () => {
        return (
            <div className="task-modal-wrap">
                <Spin className="task-spin" size="large" tip="Auto generating documents for your task" spinning={loading}>
                <Form
                    className='task-form'
                    form={form}
                    onValuesChange={handleValuesChange}
                >
                    <div className="create-task-title">Create new task</div>
                    <div className="create-task-content">
                    <Row style={{marginBottom: 18}} gutter={20}>
                                    <Col className="gutter-row" span={24} md={11}>
                                        <div className="form-item-label">Assign to</div>
                                        <Form.Item
                                            name="borrower" 
                                            rules={[
                                                {
                                                    required: true,
                                                    message: `borrower is required.`,
                                                }
                                            ]}
                                        >
                                            <Select
                                                className="task-select"
                                                mode="multiple"
                                                maxTagCount="responsive"
                                                tagRender={tagRender}
                                                style={{
                                                width: '100%',
                                                }}
                                                placeholder="Select borrower"
                                                options={getNameOptions()}
                                            />
                                        </Form.Item>
                                        </Col>
                                    <Col className="gutter-row" span={24} md={5}>
                                        <div className="form-item-label">Due date</div>
                                            <Form.Item
                                                name="dueDate"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `Due date is required.`,
                                                    }
                                                ]}
                                            >
                                                <DatePicker
                                                    style={{width: '100%'}}
                                                    className='task-date'
                                                    disabledDate={disabledDate}
                                                    placeholder="MM/DD/YYYY"
                                                    format={{
                                                        format: "MM/DD/YYYY",
                                                        type: 'mask',
                                                    }}
                                                    suffixIcon={null}
                                                />
                                            </Form.Item>
                                    </Col>
                                    <Col className="gutter-row" span={24} md={8}>
                                        <div className="form-item-label">Type</div>
                                            <Form.Item
                                                name="type"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `Type is required.`,
                                                    }
                                                ]}
                                            >
                                                <Select
                                                    className="task-select"
                                                    placeholder="Select task type"
                                                    style={{
                                                    width: '100%',
                                                    }}
                                                    options={typeOptions}
                                                    onChange={typeChange}
                                                />
                                            </Form.Item>
                                    </Col>
                                </Row>
                            {
                                form.getFieldValue('type') === 'sign' && (
                                    <div className="task-signature">
                                        <div className="form-item-label">Document requires signature</div>
                                        <Dragger {...draggerProps}>
                                            <div style={{height: 68, display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: 16}}>
                                                <div className="ant-upload-text"><span style={{color: '#222'}}>Drag & Drop or </span><span style={{color: '#325CEB', textDecoration: 'underline', fontWeight: 500}}>Choose a File</span></div>
                                                <div className="ant-upload-hint" style={{color: '#6E6E70'}}>
                                                    to upload requiring signature
                                                </div>
                                            </div>
                                        </Dragger>
                                    </div>
                                )
                            }
                            <div className="task-documents">
                                {
                                    taskDocuments.length > 0 && (
                                        <>
                                            <div className="form-item-label">{form.getFieldValue('type') === 'upload' ?  'Task documents' : form.getFieldValue('type') === 'sign' ? 'Uploaded files' : 'Added action items'}  {form.getFieldValue('type') !== 'sign' && <span>({taskDocuments.length})</span>}</div>
                                            <div className="table-wrap"><Table className="task-table" components={components} ref={tableRef} scroll={{ y: 288 }} pagination={false} columns={columns} dataSource={taskDocuments} /></div>
                                        </>
                                    )
                                }
                                {
                                    (form.getFieldValue('type') === 'action') && (
                                        addDocument ? (
                                            <div className="add-document">
                                                <div className="add-document-title">{taskType() === 'upload' ? 'Add new document to the task' : 'New action item'}</div>
                                                <div className="add-document-content">
                                                    <Row gutter={20}>
                                                        <Col className="gutter-row" span={24} md={taskType() === 'upload' ? 9 : 18}>
                                                            <div className="add-document-label">{taskType() === 'upload' ? 'Document' : 'Item description'}</div>
                                                            <Form.Item
                                                                name="name" 
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: `${ taskType() === 'upload' ? 'Document' : 'Item description'} is required.`,
                                                                    }
                                                                ]}
                                                                
                                                            >
                                                                <div>
                                                                    <AutoComplete
                                                                        className="task-select"
                                                                        style={{
                                                                            width: '100%',
                                                                        }}
                                                                        onSelect={(value) => form.setFieldsValue({name: value})}
                                                                        onChange={(value) => changeDocumentName(value)}
                                                                        onFocus={() => changeDocumentName('')}
                                                                        placeholder={taskType() === 'upload' ? 'Select document' : 'Enter description'}
                                                                    >
                                                                        { documentOptions.length ? documentOptions.map((val, index) => (
                                                                            <AutoComplete.Option key={val} value={val}>
                                                                            {val}
                                                                            </AutoComplete.Option>
                                                                        ))
                                                                        : null}
                                                                    </AutoComplete>
                                                                </div>
                                                            </Form.Item>
                                                            </Col>
                                                        <Col className="gutter-row" span={24} md={6}>
                                                            <div className="add-document-label">Deadline</div>
                                                            <Form.Item
                                                                name="addDueDate"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: `Due date is required.`,
                                                                    }
                                                                ]}
                                                            >
                                                                <DatePicker
                                                                    style={{width: '100%'}}
                                                                    className='task-date'
                                                                    disabledDate={disabledDate}
                                                                    placeholder="MM/DD/YYYY"
                                                                    format={{
                                                                        format: "MM/DD/YYYY",
                                                                        type: 'mask',
                                                                    }}
                                                                    suffixIcon={null}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                        {
                                                            taskType() === 'upload' && (
                                                                <Col className="gutter-row" span={24} md={9}>
                                                                    <div className="add-document-label">Leave a message(optional)</div>
                                                                    <Form.Item 
                                                                        name="message" 
                                                                    >
                                                                        <Input className='task-input' placeholder="Enter your message here..."  />
                                                                    </Form.Item>
                                                                </Col>
                                                            )
                                                        }
                                                    </Row>
                                                </div>
                                                <div className="add-document-operate">
                                                    <Button className="add-document-cancel" type="link" onClick={cancelDocument}>Cancel</Button>,
                                                    <Button className="add-document-save" onClick={saveDocument}>Add</Button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="add-document-btn"><span style={{cursor: 'pointer'}} onClick={changeAddDocument}>Add more</span></div>
                                        )
                                    )
                                }
                                
                            </div>
                    </div>
                    </Form>
                </Spin>
            </div>
        )
    }

    const showSucceed = () => {
        return <div className="success-wrap">
            <img src="/images/congratulation.png" />
            <div className="success-title">Task created successfully!</div>
            <div className='success-subtitle'>We've also sent an email to <span className='email'>{form.getFieldValue('borrower').length > 1 ? props.application.borrower.email : props.application[form.getFieldValue('borrower')[0]].email}</span> to notify your borrower that they've just received a new task.</div>
        </div>
    }

    const updateTasks = (taskId) => {
        let token = sessionStorage.getItem("ZeitroA")
        let borrowerValue = form.getFieldValue('borrower')
        let forwhom = borrowerValue.length === 1 ? borrowerValue[0] : 'joint'
        let data = {
            TaskID: taskId.toString(),
            LoanID: props.loanid,
        }
        if (form.getFieldValue('type') === 'action') {
            data.Items = taskDocuments.filter(doc => doc.remove).map(doc => ({ DueDate: doc.duedate, Description: doc.name }))
        } else {
            data.Documents = taskDocuments.filter(doc => doc.remove).map(doc => ({ Name: doc.name, DueDate: doc.duedate, Message: doc.message, ForWhom: forwhom }))
        }
        let api = form.getFieldValue('type') === 'action' ? '/los/additemtouseractionitems' : '/los/adddocumentstousertask'
        setSaveLoading(true)
        fetch(api, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                setSaveLoading(false)
                if (response.status !== 200) {
                    message.error('something went wrong please try later')
                    return;
                }
                setShowCreateNewModal(false)
                message.success({
                    type: 'success',
                    content: 'Add item successful!',
                })
                getusertasks()
            }
    
        ).catch((err) => {
            setSaveLoading(false)
            message.error('something went wrong please try later')
        })
    }
    const updateSignTask = (taskId) => {
        let token = sessionStorage.getItem("ZeitroA")    
        const formData = new FormData()
        taskDocuments.filter(doc => doc.remove).forEach(({ file, markList, scale }, index) => {
            formData.append(`files`, file)
            formData.append(`markLists[${index}]`, JSON.stringify(markList))
            formData.append(`scales[${index}]`, scale.toString())
        })
        setSaveLoading(true)
        fetch("/los/addusersigndoctotask", {
            cache: 'no-cache',
            method: 'POST',
            body: formData,
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "X-Loan": props.loanid,
                "X-ForWhom": form.getFieldValue('borrower').length === 1 ? form.getFieldValue('borrower')[0] : 'joint',
                "X-DueDate": dayjs(form.getFieldValue('dueDate')).format('MM/DD/YYYY'),
                "X-TaskID": taskId
            },
        }).then(response => {
            setSaveLoading(false)
            if (response.status !== 200) {
                message.error('something went wrong please try later')
                return;
            }            
            setShowCreateNewModal(false)
            message.success({
                type: 'success',
                content: 'Add item successful!',
            })
            getusertasks()

        }).catch(error => {
            setSaveLoading(false)
            message.error('something went wrong please try later')
        })
    }
    const saveSignTask = () => {
        let token = sessionStorage.getItem("ZeitroA")    
        const formData = new FormData()
        taskDocuments.forEach(({ file, markList, scale }, index) => {
            formData.append(`files`, file)
            formData.append(`markLists[${index}]`, JSON.stringify(markList))
            formData.append(`scales[${index}]`, scale.toString())
        })
        setSaveLoading(true)
        fetch("/los/saveusersigntask", {
            cache: 'no-cache',
            method: 'POST',
            body: formData,
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "X-Loan": props.loanid,
                "X-ForWhom": form.getFieldValue('borrower').length === 1 ? form.getFieldValue('borrower')[0] : 'joint',
                "X-DueDate": dayjs(form.getFieldValue('dueDate')).format('MM/DD/YYYY'),
            },
        }).then(response => {
            setSaveLoading(false)
            if (response.status !== 200) {
                message.error('something went wrong please try later')
                return;
            }            
            setSucceed(true)
            getusertasks()

        }).catch(error => {
            setSaveLoading(false)
            message.error('something went wrong please try later')
        })
    }

    const saveTasks = () => {
        // if success, return status OK
        console.log(form.getFieldValue('borrower'))
        let token = sessionStorage.getItem("ZeitroA")
        let borrowerValue = form.getFieldValue('borrower')
        let forwhom = borrowerValue.length === 1 ? borrowerValue[0] : 'joint'
        console.log(taskDocuments)
        let data = {
            TaskName: form.getFieldValue('taskName'),
            LoanID: props.loanid,
            Type: form.getFieldValue('type'), // upload, sign, action
            DueDate: dayjs(form.getFieldValue('dueDate')).format('MM/DD/YYYY'),
            ForWhom: forwhom, 
        }
        if (form.getFieldValue('type') === 'action') {
            data.Items = taskDocuments.map(doc => ({ DueDate: doc.duedate, Description: doc.name }))
        } else {
            data.Docs = taskDocuments.map(doc => ({ Name: doc.name, DueDate: doc.duedate, Message: doc.message, ForWhom: forwhom }))
        }
        let api = form.getFieldValue('type') === 'action' ? '/los/saveuseractionitems' : '/los/saveusertasks'
        setSaveLoading(true)
        fetch(api, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                setSaveLoading(false)
                if (response.status !== 200) {
                    message.error('something went wrong please try later')
                    return;
                }
                if (response.status === 200 ) {
                    setSucceed(true)
                    getusertasks()
                }
            }
    
        ).catch((err) => {
            setSaveLoading(false)
            message.error('something went wrong please try later')
        })
    }
    const taskSave = () => {
        validateForm()
    }
    const taskCancel = () => {
        setShowCreateNewModal(false)
    }
    const signatureCancel = () => {
        modal.confirm({
            title: 'Are you sure?',
            content: 'Are you sure you want to leave without saving?',
            okText: 'Discard',
            cancelText: 'Cancel',
            onOk: () => {
                setShowSignatureModal(false)
            },
            onCancel: () => {

            },
        })
    }
    const onDocumentLoadSuccess = ({ numPages }) => {
        console.log(numPages)
        setNumPages(numPages)
        setPageNumber(1)
    }
    const onChangePage = (page, pageSize) => {
        setPageNumber(page)
    }
    const handleResize = (type, index, e, direction, ref, delta, position) => {
        const newMarkList = [...markList]
        const currentPageMark = curentPageMark()
        currentPageMark[type][index] = { ...currentPageMark[type][index], ...position, width: parseInt(ref.style.width, 10), height: parseInt(ref.style.height, 10) }
        setMarkList(newMarkList)
    }
    const handleDragStop = (type, index, e, d) => {
        const newMarkList = [...markList]
        const currentPageMark = curentPageMark()
        currentPageMark[type][index] = { ...currentPageMark[type][index], x: d.x, y: d.y }
        setMarkList(newMarkList)
    }
    const curentPageMark = () => {
        let current = markList.find(item => item.page === pageNumber)
        if (!current) {
            setMarkList([...markList, { page: pageNumber, signature: [], date: [] }])
            return { page: pageNumber, signature: [], date: [] }
        } else {
            return current
        }
    }
    const addMark = (type) => {
        const newMarkList = [...markList]
        const currentPageMark = curentPageMark()
        console.log(currentPageMark)
        let scrollTop = 0
        if (containerRef.current) {
            scrollTop = containerRef.current.scrollTop
        }
        currentPageMark[type].push({ x: 100, y: 100 + scrollTop, width: 266, height: 44 })
        setMarkList(newMarkList)
    }
    const removeMark = (e, type, index) => {
        const newMarkList = [...markList]
        const currentPageMark = curentPageMark()
        currentPageMark[type] = currentPageMark[type].filter((_, i) => i !== index)
        setMarkList(newMarkList)
    }
    const handleZoom = (type) => {
        if (type === 'add') {
            setScale(prevScale => +(Math.min(prevScale + 0.1, 3).toFixed(1)))
        } else {
            setScale(prevScale => +(Math.max(prevScale - 0.1, 0.5).toFixed(1)))
        }
    }
    const saveMark = () => {
        const newObject = {
            file: uploadFile,
            name: uploadFile.name,
            markList,
            scale,
            duedate: dayjs().add(3, 'day').format('MM/DD/YYYY'),
            message: '',
            remove: true, 
        }
        const updatedTaskDocuments = [...taskDocuments, newObject]
        console.log(updatedTaskDocuments)
        setTaskDocuments(updatedTaskDocuments)
        setShowSignatureModal(false)
    }
    const footer = [
        <Button className="task-btn-cancel" type="link" onClick={taskCancel}>Cancel</Button>,
        <Button className="task-btn-save" type="primary" disabled={taskDocuments.length === 0 } loading={saveLoading} onClick={taskSave}> 
            Save and send notification
        </Button>
    ]
    const markDropdownItems = [
        {
            label: <div>Delete field</div>,
            key: '0',
        }
    ]
    const signatureTypeItems = [
        {
            label: <div>Add signature</div>,
            key: 'signature',
        },
        {
            label: <div>Add date</div>,
            key: 'date',
        }
    ]
    const transitionCancel = () => {
        setHandleTransitionOpen(false)
    }
    const goDocument = () => {
        props.changeTab('documentChecklist')
    }
    return (
        <div>
            {contextHolder}
            {showCurrentTasks()}
            <Modal
                className="signature-modal"
                width={976}
                maskClosable={false}
                centered={true}
                open={showSignatureModal}
                title=""
                onCancel={signatureCancel}
                footer={null}
            >
                
                <div className='signature-top'><LeftOutlined style={{fontSize: 16, marginRight: 12}} /> Add e-signatures | {uploadFile?.name}</div>
                <div className='signature-document-wrap'>
                    <div ref={containerRef} className='signature-document'>
                        <Document style={{width: 900 * scale}} className='signature-document-pdf' file={uploadFile} onLoadSuccess={onDocumentLoadSuccess} >
                            <Page pageNumber={pageNumber} width={900 * scale}>
                                {curentPageMark().signature.map((rect, index) => (
                                    <Rnd
                                        key={index}
                                        bounds="parent"
                                        size={{ width: rect.width, height: rect.height }}
                                        position={{ x: rect.x, y: rect.y }}
                                        onResize={(e, direction, ref, delta, position) =>
                                            handleResize('signature', index, e, direction, ref, delta, position)
                                        }
                                        onDragStop={(e, d) => {
                                            handleDragStop('signature', index, e, d);
                                        }}
                                    >
                                        <Dropdown
                                            menu={{
                                                items:markDropdownItems,
                                                onClick: (e) => removeMark(e, 'signature', index)
                                            }}
                                            trigger={['click']}
                                        >
                                            <div className='rectangle-sign'></div>
                                        </Dropdown>
                                    </Rnd>
                                ))}
                                {curentPageMark().date.map((rect, index) => (
                                    <Rnd
                                        key={index}
                                        bounds="parent"
                                        size={{ width: rect.width, height: rect.height }}
                                        position={{ x: rect.x, y: rect.y }}
                                        onResize={(e, direction, ref, delta, position) =>
                                            handleResize('date', index, e, direction, ref, delta, position)
                                        }
                                        onDragStop={(e, d) => {
                                            handleDragStop('date', index, e, d);
                                        }}
                                    >
                                        <Dropdown
                                            menu={{
                                                items:markDropdownItems,
                                                onClick: (e) => removeMark(e, 'date', index)
                                            }}
                                            trigger={['click']}
                                        >
                                            <div className='rectangle-sign'></div>
                                        </Dropdown>
                                    </Rnd>
                                ))}
                            </Page>
                        </Document>
                    </div>
                    <div className='document-pdf-zoom'>
                        <div className='zoom-min'><MinusOutlined onClick={() =>handleZoom('min')} /></div>
                        <div className='zoom-value'>{Math.round(scale * 100)}%</div>
                        <div className='zoom-add'><PlusOutlined onClick={() =>handleZoom('add')} /></div>
                    </div>
                </div>
                <Row justify='space-between' className='signature-bar'>
                    <Col md={6} span={24}><Pagination size='small' simple current={pageNumber} pageSize={1} total={numPages} onChange={onChangePage} /></Col>
                    <Col md={18} span={24} className='signature-bar-btn'>
                        <span className='signatures-num'>{curentPageMark().signature.length} signatures</span>
                        <span className='signatures-num'>{curentPageMark().date.length} date</span>
                        <Dropdown
                            menu={{
                                items:signatureTypeItems,
                                onClick: (e) => addMark(e.key)
                            }}
                            placement="topRight"
                            trigger={['click']}
                        >
                            <Button className="add-signature">Add <img style={{marginLeft: 4}} src='/images/arrow-signature.svg' /></Button>
                        </Dropdown>
                        <div className='divider'></div>
                        <Button className="save-signature" disabled={!markList.some(item => item.signature.length > 0)} onClick={saveMark} type="primary">Save</Button>
                    </Col>
                </Row>
            </Modal>
            <Modal
                className="create-task-modal"
                width={succeed ? 566 : 976}
                styles={{ body: { height: succeed ? "auto" : '85vh' } }}
                centered={true}
                open={showCreateNewModal}
                title=""
                onCancel={taskCancel}
                footer={succeed ? null : footer}
            >
                {succeed ? showSucceed() : showCreateNewTasks()}
                
            </Modal>
            <Modal
                className='transition-modal'
                centered
                maskClosable={false}
                width={706}
                open={handleTransitionOpen}
                onCancel={transitionCancel}
                footer={null}
            >   
                <div className='transition-title'><img src='/images/document/zeitro-logo.svg'/><div className='transition-title-text'>Introducing New <span style={{color: '#1630AC'}}>DOCUMENTS</span></div></div>
                <div className='transition-content'>
                    <div>The "<span className='content-bold'>Create document upload tasks</span>" feature is now integrated into the <span className='content-bold'>Documents</span> page. You can now enjoy AI-powered document requests, reviews, and verification all in one place!</div>
                    <div>To send document requests to your borrowers, simply go to <span className='content-bold'>Documents</span> and click “ <span className='content-bold'>+ Add Document</span> ”.</div>
                    <div>Thanks for being part of our journey to enhance your experience!</div>
                </div>
                <div style={{textAlign: 'center'}}><Button className="transition-btn" type="primary" onClick={goDocument}>Take me to Documents</Button></div>
            </Modal>               
        </div>
    )
}
Tasks = connect(mapStateToProps, mapDispatchToProps)(Tasks);